/* ============================================================
   BOOTWORLD — Product Detail Page JS
   Image Gallery | Size Selector | Sticky Bar | Accordion | ATC
   ============================================================ */

(function () {
  'use strict';

  /* ── Image Gallery ────────────────────────────────────────────── */
  function switchImage(thumb) {
    if (!thumb) return;
    const mainImg = document.getElementById('pdp-main-img') || document.querySelector('.pdp-gallery__main img');
    if (!mainImg) return;

    const src = thumb.dataset.src || thumb.querySelector('img')?.getAttribute('src');
    if (!src) return;

    const alt = thumb.dataset.alt || thumb.querySelector('img')?.getAttribute('alt');
    if (alt) mainImg.alt = alt;

    mainImg.style.opacity = '0';
    setTimeout(() => {
      mainImg.src = src;
      mainImg.style.opacity = '1';
    }, 150);

    const parent = thumb.parentElement;
    if (parent) {
      parent.querySelectorAll('.pdp-gallery__thumb').forEach(t => t.classList.remove('active'));
    }
    thumb.classList.add('active');
  }

  function initGallery() {
    const mainImg  = document.getElementById('pdp-main-img') || document.querySelector('.pdp-gallery__main img');
    const thumbs   = document.querySelectorAll('.pdp-gallery__thumb');
    if (!mainImg || !thumbs.length) return;

    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', (e) => {
        e.preventDefault();
        switchImage(thumb);
      });
    });

    // Touch swipe support
    let touchStartX = 0;
    const gallery = document.querySelector('.pdp-gallery__main');
    if (!gallery) return;

    const thumbsArr = [...thumbs];
    let currentIdx = 0;

    gallery.addEventListener('touchstart', e => { touchStartX = e.touches[0].clientX; }, { passive: true });
    gallery.addEventListener('touchend', e => {
      const delta = e.changedTouches[0].clientX - touchStartX;
      if (Math.abs(delta) < 50) return;
      currentIdx = delta < 0
        ? Math.min(currentIdx + 1, thumbsArr.length - 1)
        : Math.max(currentIdx - 1, 0);
      if (thumbsArr[currentIdx]) {
        switchImage(thumbsArr[currentIdx]);
      }
    });
  }

  window.switchPdpImage = switchImage;

  /* ── Size Selector ────────────────────────────────────────────── */
  function initSizeSelector() {
    const sizeBtns   = document.querySelectorAll('.pdp-size-btn');
    const atcBtn     = document.querySelector('[data-pdp-atc], [data-quick-add]');
    const buyNowBtn  = document.querySelector('[data-pdp-buy-now]');
    const stickyBtn  = document.querySelector('[data-sticky-atc]');
    const stickyBar  = document.querySelector('.pdp-sticky-bar');
    let selectedVariantId = null;

    // Pre-select initial button if present
    const initialBtn = document.querySelector('.pdp-size-btn.selected');
    if (initialBtn) {
      selectedVariantId = initialBtn.dataset.variantId;
      const displayEl = document.getElementById('pdp-selected-size-display');
      if (displayEl) {
        displayEl.textContent = initialBtn.dataset.size || ('UK ' + initialBtn.textContent.trim());
      }
    }

    sizeBtns.forEach(btn => {
      btn.addEventListener('click', () => {
        if (btn.classList.contains('unavailable')) return;
        sizeBtns.forEach(b => b.classList.remove('selected'));
        btn.classList.add('selected');
        selectedVariantId = btn.dataset.variantId;
        const sizeLabel = btn.dataset.size || ('UK ' + btn.textContent.trim());

        // Update selected size label in header
        const displayEl = document.getElementById('pdp-selected-size-display');
        if (displayEl) {
          displayEl.textContent = sizeLabel;
        }

        // Update ATC button dataset
        if (atcBtn) {
          if (selectedVariantId) atcBtn.dataset.variantId = selectedVariantId;
          atcBtn.dataset.size = sizeLabel;
        }
        if (buyNowBtn) {
          if (selectedVariantId) buyNowBtn.dataset.variantId = selectedVariantId;
          buyNowBtn.dataset.size = sizeLabel;
        }

        // Update price
        const price    = btn.dataset.price;
        const origPrice = btn.dataset.comparePrice;
        const priceEl  = document.querySelector('.pdp-info__price');
        const origEl   = document.querySelector('.pdp-info__price-orig');
        const stickPriceEl = document.querySelector('.pdp-sticky-bar__price');

        if (priceEl && price)    priceEl.textContent   = formatMoney(parseInt(price));
        if (origEl)              origEl.textContent     = origPrice && origPrice !== price ? formatMoney(parseInt(origPrice)) : '';
        if (stickPriceEl && price) stickPriceEl.textContent = formatMoney(parseInt(price));

        // Enable ATC
        if (atcBtn) {
          atcBtn.disabled = false;
        }
      });
    });

    // Add to cart
    async function doAddToCart() {
      if (!selectedVariantId) {
        // Scroll to size selector and flash it
        const sizeSection = document.querySelector('.pdp-size-label');
        if (sizeSection) sizeSection.scrollIntoView({ behavior: 'smooth', block: 'center' });
        sizeBtns.forEach(b => {
          b.style.borderColor = 'var(--bw-gold)';
          setTimeout(() => b.style.borderColor = '', 1200);
        });
        if (window.BW) window.BW.showToast('👆 Please select your UK size first');
        return;
      }

      const btn = atcBtn || stickyBtn;
      if (btn) { btn.textContent = 'Adding…'; btn.disabled = true; }

      try {
        const selectedBtn = document.querySelector('.pdp-size-btn.selected');
        let selectedSize = 'UK 8';
        if (selectedBtn) {
          selectedSize = selectedBtn.dataset.size || ('UK ' + selectedBtn.textContent.trim());
        }

        // 1. Add to Shopify server cart via API
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ id: selectedVariantId, quantity: 1, properties: { Size: selectedSize } })
        });

        // 2. Sync and open CartDrawer
        if (window.BW && window.BW.CartDrawer) {
          await window.BW.CartDrawer.open();
        }
        if (window.BW && window.BW.showToast) {
          window.BW.showToast('✅ Added to cart!');
        }
      } catch (err) {
        if (window.BW) window.BW.showToast('❌ Could not add to cart. Please try again.');
      } finally {
        if (btn) { btn.textContent = 'Add to Cart'; btn.disabled = false; }
      }
    }

    if (atcBtn) atcBtn.addEventListener('click', doAddToCart);
    if (stickyBtn) stickyBtn.addEventListener('click', doAddToCart);

    // Buy now
    if (buyNowBtn) {
      buyNowBtn.addEventListener('click', async (e) => {
        e.preventDefault();
        const selectedBtn = document.querySelector('.pdp-size-btn.selected');
        const effectiveVariantId = selectedVariantId || selectedBtn?.dataset.variantId || buyNowBtn.dataset.variantId;
        const selectedSize = selectedBtn?.dataset.size || document.getElementById('pdp-selected-size-display')?.textContent.trim() || 'UK 8';

        buyNowBtn.textContent = 'CHECKING OUT… ⚡';
        buyNowBtn.disabled = true;

        if (window.BW && window.BW.LocalCart) {
          const layout = buyNowBtn.closest('.pdp-layout') || document;
          const title = layout.querySelector('.pdp-info__title')?.textContent.trim() || 'Bootworld Cleats';
          const priceStr = layout.querySelector('.pdp-info__price')?.textContent.trim() || '₹21,999';
          const image = document.getElementById('pdp-main-img')?.src || '';
          const buyItem = {
            title: title,
            price: priceStr,
            image: image,
            size: selectedSize,
            quantity: 1,
            variant_id: effectiveVariantId
          };
          try {
            sessionStorage.setItem('bw_buy_now_item', JSON.stringify(buyItem));
          } catch(e){}
          window.BW.LocalCart.addItem(buyItem);
        }

        try {
          if (effectiveVariantId) {
            await fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
              body: JSON.stringify({ id: effectiveVariantId, quantity: 1, properties: { Size: selectedSize } })
            });
          }
        } catch (err) {
          console.warn('Cart add error:', err);
        }

        window.location.href = '/checkout';
      });
    }

    // Sticky bar show/hide
    if (stickyBar) {
      const atcSection = document.querySelector('.pdp-atc-row');
      if (atcSection) {
        const obs = new IntersectionObserver(entries => {
          stickyBar.style.display = entries[0].isIntersecting ? 'none' : 'flex';
        }, { threshold: 0 });
        obs.observe(atcSection);
      }
    }
  }

  /* ── Accordion ────────────────────────────────────────────────── */
  function initAccordion() {
    document.querySelectorAll('.accordion-trigger').forEach(trigger => {
      trigger.addEventListener('click', () => {
        const body     = trigger.nextElementSibling;
        const expanded = trigger.getAttribute('aria-expanded') === 'true';
        // Collapse all
        document.querySelectorAll('.accordion-trigger').forEach(t => {
          t.setAttribute('aria-expanded', 'false');
          t.nextElementSibling?.classList.remove('open');
        });
        // Toggle clicked
        if (!expanded) {
          trigger.setAttribute('aria-expanded', 'true');
          body?.classList.add('open');
        }
      });
    });
  }

  /* ── Format Money ─────────────────────────────────────────────── */
  function formatMoney(val) {
    if (!val) return '₹19,999';
    let num = parseInt(val, 10);
    if (isNaN(num)) return '₹19,999';
    if (num > 100000) num = Math.round(num / 100);
    return '₹' + num.toLocaleString('en-IN');
  }

  /* ── Related Products Carousel ────────────────────────────────── */
  function initRelatedCarousel() {
    const track = document.querySelector('.related-carousel__track');
    const prevBtn = document.querySelector('[data-carousel-prev]');
    const nextBtn = document.querySelector('[data-carousel-next]');
    if (!track) return;

    const scrollBy = track.offsetWidth * 0.85;

    prevBtn?.addEventListener('click', () => track.scrollBy({ left: -scrollBy, behavior: 'smooth' }));
    nextBtn?.addEventListener('click', () => track.scrollBy({ left:  scrollBy, behavior: 'smooth' }));
  }

  /* ── Init ─────────────────────────────────────────────────────── */
  document.addEventListener('DOMContentLoaded', () => {
    initGallery();
    initSizeSelector();
    initAccordion();
    initRelatedCarousel();
  });

})();
